module.exports = __webpack_public_path__ + "img/西藏大学.9c5bad84.png";